/** Converts an object's keys from camelCase to PascalCase, omitting undefined values. */
export function toPascalCaseParams(params: Record<string, unknown>): Record<string, unknown> {
  const result: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined) {
      result[key.charAt(0).toUpperCase() + key.slice(1)] = value;
    }
  }
  return result;
}
